<template>
  <!-- 店铺信息-基本信息 -->
  <div class="BasicInformation">
    <!-- 公司名 logo -->
    <div class="shop-basic-msg">
      <img
        src="../../../../../../assets/imgs/logo.svg"
        alt=""
      />
      <div class="shop-mark-guarantee">
        <div class="shop-Name">xxx科技发展有限公司</div>
        <div class="shop-mark">ID:66225511333888</div>
      </div>
      <!-- 公司简介 -->
      <div class="intro">
        <div class="intro-cen">
          <p class="title">公司简介：</p>
          <p class="introContent">
            喀什最大最高端的楼盘，只要认真对待工作，每月工资最少都在2万以上，感兴趣可以联系我
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  watch: {},
  components: {},
  created() {},
  methods: {},
};
</script>

<style scoped lang="less">
.BasicInformation {
  width: 100%;
  height: 100%;
  //   基本信息
  .shop-basic-msg {
    height: 60px;
    background: #ffffff;
    border: 1px solid #eeeeee;
    border-radius: 5px;
    display: flex;
    padding: 20px;
    img {
      width: 60px;
      height: 60px;
    }
    // 公司名 id 评分 保障
    .shop-mark-guarantee {
      min-width: 330px;
      height: 60px;
      margin-left: 30px;
      display: flex;
      flex-direction: column;
      //
      .shop-Name {
        width: 100%;
        height: 20px;
        line-height: 20px;
        display: flex;
        font-size: 20px;
        color: #333333;
      }
      .shop-mark {
        height: 20px;
        width: 100%;
        height: 14px;
        line-height: 14px;
        margin-top: 20px;
        display: flex;
        font-size: 12px;
        color: #333333;
      }
    }
    // 公司简介
    .intro {
      flex: 1;
      height: 70px;
      display: flex;
      .intro-cen {
        width: 400px;
        height: 70px;
        margin: auto;
        display: flex;
        flex-direction: column;
        font-size: 12px;
        color: #333333;
        .title {
          width: 100%;
          height: 14px;
          margin-bottom: 10px;
        }
        .introContent {
          width: 100%;
          flex: 1;
        }
      }
    }
  }
}
</style>
